import clsx from 'clsx';
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  fullHeight?: boolean;
  gap?: number;
  height?: number;
  maxWidth?: number;
  noPadding?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, className, fullHeight, height, gap = 16, maxWidth, noPadding }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'display-scrollbar-lg flex w-full flex-col overflow-auto rounded-[4px] border border-base-300 bg-base-100',
          fullHeight ? 'h-full' : 'h-fit',
          !noPadding && 'p-4',
          className
        )}
        style={{ gap, height, maxWidth }}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';

export default Card;
